import React from 'react';
import { Button } from '../ui/Button';
const FAQS = [{
  q: '¿Es digital?',
  a: 'Sí, acceso inmediato desde cualquier dispositivo'
}, {
  q: '¿Funciona si mi bebé se despierta mucho?',
  a: 'Sí, está diseñado para eso'
}, {
  q: '¿Tengo que dejarlo llorar?',
  a: 'No, en ningún momento'
}, {
  q: '¿Es mágico?',
  a: 'No, es un sistema realista y aplicable'
}];
export function FAQ() {
  return <section className="py-10 px-4 bg-white" data-id="element-25">
      <div className="max-w-3xl mx-auto" data-id="element-26">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-8" data-id="element-27">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-3 mb-10" data-id="element-28">
          {FAQS.map((faq, i) => <div key={i} className="bg-gray-50 rounded-lg p-5 border border-gray-200" data-id="element-29">
              <h3 className="font-bold text-lg text-gray-900 mb-1" data-id="element-30">{faq.q}</h3>
              <p className="text-gray-700 font-medium" data-id="element-31">{faq.a}</p>
            </div>)}
        </div>

        <div className="text-center bg-yellow-50 rounded-2xl p-6 md:p-10 border border-yellow-100" data-id="element-32">
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 uppercase" data-id="element-33">
            💛 DORMIR MEJOR TAMBIÉN ES UNA FORMA DE AMAR
          </h3>

          <div className="text-xl text-gray-800 mb-6 space-y-1 font-medium" data-id="element-34">
            <p data-id="element-35">No necesitás entrenar a tu bebé</p>
            <p data-id="element-36">Necesitás comprenderlo</p>
            <p className="font-bold text-2xl mt-3" data-id="element-37">
              👉 Y ahora sabés cómo hacerlo
            </p>
          </div>

          <Button href="https://checkout.mediosdigitalespro.online/cart/42525422551111:1" size="xl" className="w-full md:w-auto mb-4" data-id="element-38">
            👉 ACCEDÉ AHORA AL MEGAPACK
          </Button>

          <div className="text-gray-700 font-bold text-lg" data-id="element-39">
            <p data-id="element-40">Empezá HOY a cambiar tus noches</p>
            <p data-id="element-41">Y recuperá el descanso sin culpa 💛</p>
          </div>
        </div>
      </div>
    </section>;
}